"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var DrawerTitle = __importStar(require("./M_DrawerTitle"));
var PageHeader = __importStar(require("./O_PageHeaderSmall"));
var icons_1 = require("./icons");
var ArticleGroup = __importStar(require("./O_ArticleGroup"));
var AddArticleModal = __importStar(require("./O_AddArticleModal"));
var Component = function (p) {
    var onAddAr = function () {
        p.onAddModel(p.productId, 'ar-model');
    };
    var _a = Hooks.useState(false), showAddArticleModal = _a[0], setShowAddArticleModal = _a[1];
    var _b = Hooks.useState(false), addArticleModalDisabled = _b[0], setAddArticleModalDisabled = _b[1];
    var _c = Hooks.useState(false), addArticleFailed = _c[0], setAddArticleFailed = _c[1];
    var onAddArticle = function () {
        setShowAddArticleModal(true);
    };
    var onCreateArticle = function (articleType) { return __awaiter(void 0, void 0, void 0, function () {
        var succeeded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAddArticleModalDisabled(true);
                    return [4 /*yield*/, p.onAddModel(p.productId, articleType)];
                case 1:
                    succeeded = _a.sent();
                    setAddArticleModalDisabled(false);
                    succeeded ? setShowAddArticleModal(false) : setAddArticleFailed(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var onCancelAddArticle = function () {
        setShowAddArticleModal(false);
        setAddArticleFailed(false);
    };
    return (Preact.h(Drawer_1.default, { open: p.isOpen, sx: { width: '672px' }, PaperProps: {
            sx: {
                width: '672px',
                paddingTop: '64px',
                paddingBottom: '16px',
                paddingX: '24px',
                boxSizing: 'border-box',
                overflowX: 'hidden',
            },
        }, variant: "persistent", anchor: "right" },
        Preact.h(DrawerTitle.Component, { title: p.productId, onCloseClick: p.onCloseClick, sx: { marginBottom: '24px', paddingTop: '16px' } }),
        Preact.h(PageHeader.Component, { header: "Articles", buttonText: "Article", buttonIcon: Preact.h(icons_1.AddIcon, null), onButtonClick: onAddArticle, sx: { marginBottom: '24px' } }),
        p.articleModels.map(function (model) { return (Preact.h(ArticleGroup.Component, { productId: p.productId, articleType: model.articleType, onCheck: p.onCheckModel, model: model, onModelStatusUpdate: p.onModelStatusUpdate, onFileUpload: p.onFileUpload, onFileDownload: p.onFileDownload, onDeleteModel: p.onDeleteModel })); }),
        Preact.h(PageHeader.Component, { header: "AR model", buttonText: "AR model", buttonIcon: Preact.h(icons_1.AddIcon, null), buttonDisabled: Boolean(p.arModel), onButtonClick: onAddAr, sx: { marginBottom: '24px' } }),
        p.arModel ? (Preact.h(ArticleGroup.Component, { productId: p.productId, articleType: p.arModel.articleType, onCheck: p.onCheckModel, model: p.arModel, onModelStatusUpdate: p.onModelStatusUpdate, onFileUpload: p.onFileUpload, onFileDownload: p.onFileDownload, onDeleteModel: p.onDeleteModel })) : null,
        Preact.h(AddArticleModal.Component, { onSubmitClick: onCreateArticle, show: showAddArticleModal, disabled: addArticleModalDisabled, failed: addArticleFailed, onCancel: onCancelAddArticle })));
};
exports.Component = Component;
